import { css } from 'styled-components';
import {
  getSpacing, SpacingName, getTypography, TypographyName, ThemedFunctor,
} from '@doveit/lego';

export const base: ThemedFunctor = ({
  theme,
  onClick,
}) => css`
  position: relative;
  border-radius: 6px;
  overflow: hidden;
  height: 5.5rem;

  ${onClick && `
    cursor: pointer;
  `}

  a {
    text-decoration: none;
    color: ${theme.palettes.neutrals.lightest};
  }

  &::after {
    content: '';
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0,0,0,0.4);
  }
`;

export const info: ThemedFunctor = ({
  theme,
}) => css`
  ${getSpacing.padding(theme, [SpacingName.SMALL, SpacingName.SMALLER])}
  color: ${theme.palettes.neutrals.lightest};
  position: absolute;
  z-index: 1;
  text-shadow: 0 2px 4px ${theme.palettes.neutrals.darkest};
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
`;

export const name: ThemedFunctor = ({
  theme,
}) => css`
  ${getTypography(theme, TypographyName.H4)}
`;

export const badge = css`
  position: absolute;
  z-index: 2;
  top: .75rem;
  right: .75rem;
  line-height: 0;
`;
